import { PhosphorIconName } from "@storeblocks/icon-ng";

/**
 * What kind of control a dev panel row is. Drives both the row's default icon
 * and which group it renders in — the panel is grouped by type so the layout
 * is identical on every page.
 *
 * Declaration order will be the render order of the groups.
 */
export const DEV_ROW_TYPES = ["toggle", "state", "action", "nav", "display"] as const;

export type DevRowType = (typeof DEV_ROW_TYPES)[number];

/** One distinct icon per type, so types are tellable apart at a glance. */
export const DEV_ROW_TYPE_ICONS = {
  toggle: "toggle-right",
  state: "sliders-horizontal",
  action: "lightning",
  nav: "arrow-square-out",
  display: "eye",
} as const satisfies Record<DevRowType, PhosphorIconName>;

export function defaultIconForType(type: DevRowType): PhosphorIconName {
  return DEV_ROW_TYPE_ICONS[type];
}
